import { TextField, FormControl, InputLabel, OutlinedInput, InputAdornment, Tooltip } from "@mui/material";
import {useRef, useEffect} from 'react';
export default function FormCash(props) {
      // Create ref for first input
      const firstInputRef = useRef(null);

      // Focus on first input when component mounts
      useEffect(() => {
          if (firstInputRef.current) {
              firstInputRef.current.focus();
          }
      }, []); // Empty dependency array means this runs once when component mounts
  
    const formatNumber = (num) => {
        if (!num) return '';
        // Remove any existing commas and non-numeric characters except decimal point
        const cleanNum = num.toString().replace(/[^\d.-]/g, '');
        // Format with commas
        return cleanNum.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        // Remove commas before saving to state
        const cleanValue = value.replace(/,/g, '');
        const finalValue = cleanValue === '' ? 0 : cleanValue;
        props.setSelectedFinancial({ ...props.selectedFinancial, [name]: finalValue });
    }

    const onChecked = (e) => {
        const { name, checked } = e.target;
        props.setSelectedFinancial({ ...props.selectedFinancial, [name]: checked });
    }

    return (
        <>
            <div className="formRow">
                <div className="formGroup">
                    <Tooltip title="Actual Cash Balance at the end of the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Balance</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.cashBalance)}
                                onChange={onChange}
                                name='cashBalance'
                                label="Balance"
                                inputRef={firstInputRef}
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Total line of Credit Capacity." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Line Capacity</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.cashLineCapacity)}
                                onChange={onChange}
                                name='cashLineCapacity'
                                label="Line Capacity"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Outstanding amounts due against the Line of Credit at the end of the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Line Balance</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.cashLineBalance)}
                                onChange={onChange}
                                name='cashLineBalance'
                                label="Line Balance"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
            </div>
            <div className="formRow">
                <div className="formGroup">
                    <Tooltip title="This is the total value of all assets reported on the balance sheet at the end of the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Assets</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.cashAssets)}
                                onChange={onChange}
                                name='cashAssets'
                                label="Assets"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Accounts Payable balance, excluding Retention at the end of the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>A/P (ex. Retention)</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.cashAP)}
                                onChange={onChange}
                                name='cashAP'
                                label="A/P (excl. Retention)"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Accounts Payable Retention balance at the end of the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>A/P Retention</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.cashAPRetention)}
                                onChange={onChange}
                                name='cashAPRetention'
                                label="A/P Retention"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
            </div>
            <div className="formRow">
                <div className="formGroup">
                    <Tooltip title="Accounts Receivable balance, excluding retention at the end of the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>A/R (excl. Retention)</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.cashAR)}
                                onChange={onChange}
                                name='cashAR'
                                label="A/R (excl. Retention)"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Accounts Receivable Retention balance at the end of the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>A/R Retention</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.cashARRetention)}
                                onChange={onChange}
                                name='cashARRetention'
                                label="A/R Retention"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Accounts Receivable balance >90 days at the end of the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>A/R Over 90</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.cashAROverdue)}
                                onChange={onChange}
                                name='cashAROverdue'
                                label="A/R over 90"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
            </div>
            <div className="formRow">
                <div className="formGroup">
                    <Tooltip title="Overbillings as reported on the balance sheet at the end of the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Overbilling (enter as a positive value)</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.cashOverbilling)}
                                onChange={onChange}
                                name='cashOverbilling'
                                label="Overbilling (enter as a positive value)"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Underbillings as reported on the balance sheet at the end of the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Underbilling (enter as a negative value)</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.cashUnderbilling)}
                                onChange={onChange}
                                name='cashUnderbilling'
                                label="Underbilling (enter as a negative value)"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Cost incurred on unapproved Change Orders that the company is proceeding on without an approved contractual change." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Change Orders Cost</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.cashChangeOrdersCost)}
                                onChange={onChange}
                                name='cashChangeOrdersCost'
                                label="Change Orders Cost"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
            </div>







        </>
    );
}